import { useTranslation } from 'react-i18next'

import { Button } from '@/Atomic/Molecules/Button'

interface DynamicListEmptyStateProps {
  onCreateFilter: () => void
}

export const DynamicListEmptyState: React.FC<DynamicListEmptyStateProps> = ({
  onCreateFilter,
}) => {
  const { t } = useTranslation()

  return (
    <div className="dynamic-list-empty-state">
      <h3 className="dynamic-list-empty-state-title">
        {t('pages.list.dynamicList.title')}
      </h3>
      <p className="dynamic-list-empty-state-subtitle">
        {t('pages.list.dynamicList.subtitle')}
      </p>
      <p className="dynamic-list-empty-state-description">
        {t('pages.list.dynamicList.description')}
      </p>
      <Button variant="outlined" icon="add" onClick={onCreateFilter}>
        {t('pages.list.dynamicList.createFilter')}
      </Button>
    </div>
  )
}
